// extracted by mini-css-extract-plugin
module.exports = {"dialogContainer":"DialogProductSearch_dialogContainer__PvjwC","dialogContent":"DialogProductSearch_dialogContent__4utw0"};